import { Inject, Injectable, Optional } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import io from 'socket.io-client';
import { CoreConfig } from '../utils/config';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  public socketStatus = false;
  public tcpSocketStatus = false;
  public comServerStatus = false;
  public ocrServerStatus = false;
  public authServerStatus = false;
  private tcpSocketStatusSubscription: Subscription;
  private ocrServerStatusSubscription: Subscription;
  private comServerStatusSubscription: Subscription;
  private authServerStatusSubscription: Subscription;
  private socket: any;

  constructor(@Inject(CoreConfig.SOCKET_IO_PATH) public socketIoPath: string, @Inject(CoreConfig.SOCKET_ROOM) public room: string, public appConfig: AppConfigService) {
    const useCustomWsUri: boolean = appConfig.getConfig().useCustomWsUri != undefined ? appConfig.getConfig().useCustomWsUri : true;
    let secureConnection: boolean = false;
    if (window.location.protocol === 'https:') secureConnection = true;

    let wsURI: string = appConfig.getConfig().wsURI;

    if (!useCustomWsUri) {
      if (secureConnection) wsURI = `wss://${window.location.host}`;
      else wsURI = `ws://${window.location.host}`;
    }

    console.log(`[webSocketService constructor] - useCustomWsUri: ${useCustomWsUri} - secureConnection: ${secureConnection} - Socket connected: ${wsURI}`);

    this.socket = io(wsURI, {
      path: socketIoPath,
      query: {
        room: room,
      },
    });

    this.checkStatus();

    this.tcpSocketStatusSubscription = this.listen('servmatStatus').subscribe((data) => {
      this.tcpSocketStatus = Boolean(data);
      console.log(`tcpSocketStatusUpdate: ${this.tcpSocketStatus}`);
      if (this.tcpSocketStatus === false) {
        this.ocrServerStatus = false;
        this.comServerStatus = false;
        this.authServerStatus = false;
      }
      console.log('servmat', this.ocrServerStatus);
    });
    this.ocrServerStatusSubscription = this.listen('ocrServerStatus').subscribe((data) => {
      this.ocrServerStatus = Boolean(data);
      console.log('ocrServerUpdate', this.ocrServerStatus);
    });
    this.comServerStatusSubscription = this.listen('comServerStatus').subscribe((data) => {
      this.comServerStatus = Boolean(data);
      console.log('comServerUpdate', this.ocrServerStatus);
    });
    this.authServerStatusSubscription = this.listen('authServerStatus').subscribe((data) => {
      this.authServerStatus = Boolean(data);
      console.log('authServerUpdate', this.ocrServerStatus);
    });
    setTimeout(() => {
      this.setInitStatus();
    }, 500);
  }

  checkStatus() {
    this.socket.on('connect', () => {
      this.socketStatus = true;
    });
    this.socket.on('disconnect', () => {
      this.socketStatus = false;
      this.tcpSocketStatus = false;
      this.ocrServerStatus = false;
      this.authServerStatus = false;
      this.comServerStatus = false;
    });
  }

  send(event: string, payload?: any) {
    this.socket.emit(event, payload);
  }

  listen(event: string): Observable<any> {
    console.log('escuchado mensaje', event);
    return new Observable((subscriber) => {
      this.socket.on(event, (data: any) => {
        subscriber.next(data);
      });
    });
  }

  setInitStatus() {
    this.send('servmatStatus');
    this.send('ocrServerStatus');
    this.send('comServerStatus');
    this.send('authServerStatus');
  }
  OnDestroy() {
    this.tcpSocketStatusSubscription.unsubscribe();
    this.ocrServerStatusSubscription.unsubscribe();
    this.comServerStatusSubscription.unsubscribe();
    this.authServerStatusSubscription.unsubscribe();
  }
}
